/* fail-safe */try{
(function () {
/* Assignment checklist — confirmed-save check-offs with an offline queue.
 *
 * Rules this file exists to enforce (from the cohort build review):
 *   - A check NEVER shows done until the server said 200. School filters eat
 *     requests; an optimistic checkmark that silently failed would put a
 *     diligent coach at 0% on their AD's report.
 *   - Failed writes queue in localStorage and retry on load and on 'online'.
 *   - The member token is fetched FRESH before every write (they die in 10
 *     minutes; the coach reads for 15 and then checks the box).
 *   - ES5 syntax throughout: athletic-department iPads run old Safari, and a
 *     SyntaxError would kill the whole file. Isolated in its own script.
 */
var API = 'https://member-api.proactivecoaching.ai';
var wrap = document.querySelector('.pca-wrap');
if (wrap) {
    var ASSIGNMENT = wrap.getAttribute('data-assignment') || '';
    var signedIn = wrap.getAttribute('data-signedin') === '1';
    var itemsBox = wrap.querySelector('.pca-items');
    var body = wrap.querySelector('.pca-body');
    var progress = wrap.querySelector('.pca-progress');
    var bar = wrap.querySelector('.pca-bar i');
    var count = wrap.querySelector('.pca-count');
    var session = wrap.querySelector('.pca-session');
    var QKEY = 'pca-q-' + ASSIGNMENT;

    function token(cb) {
        fetch('/members/api/session', { credentials: 'include' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (t) { cb(t || ''); })
            .catch(function () { cb(''); });
    }
    function itemId(li) {
        var a = li.querySelector('a');
        /* only a SAME-ORIGIN link's path can be an id — two external links
           would otherwise collide on a shared pathname like /watch */
        if (a) { try { var iu = new URL(a.href, location.origin); if (iu.origin === location.origin) return iu.pathname; } catch (e) {} }
        return 'x-' + (li.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
    }

    /* Items come from the post's structure, two conventions supported:
       EDITORIAL (the Five Things idiom, preferred): each numbered <h2> is an
       item; its section (until the next h2) supplies the first internal link,
       the kind (listen/watch/read keyword — a linkless section is a
       discussion item), and "NN min". The chip decorates the h2 in place, so
       the emailed post stays a clean letter and the site adds the tracking.
       LEGACY: the first <ul> becomes cards (v1 posts keep working). */
    function slugify(t) {
        return 'x-' + String(t || '').toLowerCase()
            .replace(/^\s*\d+\s*[\u00b7\u2014\u2013:.-]*\s*/, '')
            .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
    }
    function itemLink(el) {
        /* first SAME-ORIGIN anchor wins — an external link ahead of the real
           item link must not hide it (audit fix 2026-08-20) */
        var as = el.querySelectorAll('a');
        for (var ai = 0; ai < as.length; ai++) {
            try { var u = new URL(as[ai].href, location.origin); if (u.origin === location.origin) return { a: as[ai], path: u.pathname }; } catch (e) {}
        }
        return null;
    }
    var items = [];
    var usedIds = {};
    function uniqueId(id) {
        /* two same-titled discussion items (or twice-linked pages) must not
           share one server row */
        if (!usedIds[id]) { usedIds[id] = 1; return id; }
        usedIds[id]++;
        return id + '-' + usedIds[id];
    }
    var allH2 = body ? body.querySelectorAll('h2') : [];
    /* Only NUMBERED headings are items — the editorial idiom always numbers
       them, and a prose heading like "How this page works" must never sprout
       a button. If no heading is numbered, treat them all as items so any
       older post keeps working. */
    var h2s = [];
    for (var hf = 0; hf < allH2.length; hf++) {
        if (/^\s*\d/.test(allH2[hf].textContent || '') || allH2[hf].querySelector('.pcb-num')) h2s.push(allH2[hf]);
    }
    /* deliberately NO all-h2 fallback: on the gated (signed-out) view the
       body is only Ghost's "subscribers only" CTA, whose heading must not
       become a phantom item (verifier fix 2026-08-20); unnumbered posts fall
       through to the legacy first-<ul> mode */
    if (h2s.length) {
        for (var hi = 0; hi < h2s.length; hi++) {
            var h2 = h2s[hi];
            var sectionText = '';
            var linkPText = '';
            var link = null;
            var node = h2.nextElementSibling;
            while (node && node.tagName !== 'H2') {
                sectionText += ' ' + (node.textContent || '');
                if (!link) {
                    var found = itemLink(node);
                    if (found) { link = found; linkPText = (node.textContent || '').toLowerCase(); }
                }
                node = node.nextElementSibling;
            }
            var htext = (h2.textContent || '').toLowerCase();
            var all = htext + ' ' + sectionText.toLowerCase();
            /* kind + minutes: the line carrying the item link wins (its tail
               says "9 min · watch"), then the heading, then the section — so
               a callout mentioning "listen" above the link can't mislabel a
               watch item (audit fix 2026-08-20) */
            var kindRe = /\b(listen|watch|read)\b/;
            var kindM = kindRe.exec(linkPText) || kindRe.exec(htext) || kindRe.exec(all);
            var kind = link ? (kindM ? kindM[1] : 'read') : 'check';
            var minRe = /(\d+)\s*min(?:ute)?s?\b/;
            var minM = minRe.exec(linkPText) || minRe.exec(all);
            var expect = minM ? parseInt(minM[1], 10) * 60 : 0;
            var id = uniqueId(link ? link.path : slugify(h2.textContent));
            if (link) {
                try {
                    var lu = new URL(link.a.href, location.origin);
                    lu.searchParams.set('a', ASSIGNMENT);
                    link.a.href = lu.href;
                } catch (e) {}
            }
            var ctrl;
            if (kind === 'check') {
                ctrl = document.createElement('button');
                ctrl.className = 'pca-check'; ctrl.type = 'button';
                ctrl.textContent = 'Mark done';
                ctrl.setAttribute('data-item', id);
            } else {
                ctrl = document.createElement('span');
                ctrl.className = 'pca-check pca-earn';
                ctrl.textContent = 'Not started';
                ctrl.setAttribute('role', 'status');
            }
            ctrl.style.marginLeft = '12px';
            ctrl.style.verticalAlign = 'middle';
            h2.appendChild(ctrl);
            items.push({ id: id, btn: ctrl, done: false, kind: kind, expect: expect, path: link ? link.path : '' });
        }
    } else {
        var ul = body ? body.querySelector('ul') : null;
        if (ul) {
            wrap.className += ' pca-legacy';
            var lis = ul.querySelectorAll('li');
            for (var i = 0; i < lis.length; i++) {
                var li = lis[i], a = li.querySelector('a'), id2 = itemId(li);
                var card = document.createElement('div'); card.className = 'pca-item';
                var main = document.createElement('div'); main.className = 'pca-item-main';
                var t = document.createElement('span'); t.className = 'pca-item-t';
                if (a) {
                    var linkEl = document.createElement('a');
                    try {
                        var u2 = new URL(a.href, location.origin);
                        if (u2.origin === location.origin) u2.searchParams.set('a', ASSIGNMENT);
                        linkEl.href = u2.href;
                    } catch (e) { linkEl.href = a.href; }
                    linkEl.textContent = a.textContent;
                    t.appendChild(linkEl);
                } else {
                    t.textContent = (li.textContent || '').split('\u2014')[0].split(' - ')[0];
                }
                var rest = (li.textContent || '').replace(a ? a.textContent : t.textContent, '').replace(/^[\s\u2014\u00b7-]+/, '');
                var x = document.createElement('span'); x.className = 'pca-item-x'; x.textContent = rest;
                main.appendChild(t); if (rest) main.appendChild(x);
                var text2 = (li.textContent || '').toLowerCase();
                var kindM2 = /\b(listen|watch|read)\b/.exec(text2);
                var kind2 = a ? (kindM2 ? kindM2[1] : 'read') : 'check';
                var minM2 = /(\d+)\s*min(?:ute)?s?\b/.exec(text2);
                var expect2 = minM2 ? parseInt(minM2[1], 10) * 60 : 0;
                var ctrl2;
                if (kind2 === 'check') {
                    ctrl2 = document.createElement('button');
                    ctrl2.className = 'pca-check'; ctrl2.type = 'button';
                    ctrl2.textContent = 'Mark done';
                    ctrl2.setAttribute('data-item', id2);
                } else {
                    ctrl2 = document.createElement('span');
                    ctrl2.className = 'pca-check pca-earn';
                    ctrl2.textContent = 'Not started';
                    ctrl2.setAttribute('role', 'status');
                }
                card.appendChild(main); card.appendChild(ctrl2);
                itemsBox.appendChild(card);
                items.push({ id: id2, btn: ctrl2, done: false, kind: kind2, expect: expect2, path: a ? (function (aa) { try { return new URL(aa.href, location.origin).pathname; } catch (e) { return ''; } })(a) : '' });
            }
        }
    }

    function paint() {
        var done = 0;
        for (var i = 0; i < items.length; i++) if (items[i].done) done++;
        if (items.length && progress) {
            progress.hidden = false;
            progress.setAttribute('role', 'progressbar');
            progress.setAttribute('aria-valuemin', '0');
            progress.setAttribute('aria-valuemax', String(items.length));
            progress.setAttribute('aria-valuenow', String(done));
            bar.style.width = Math.round(done * 100 / items.length) + '%';
            count.textContent = done + ' of ' + items.length + ' done';
        }
    }
    function setBtn(it, state) {
        it.btn.className = 'pca-check' + (state ? ' ' + state : '') + (it.done ? ' is-done' : '');
        if (it.btn.tagName === 'BUTTON') it.btn.disabled = (state === 'is-busy');
        if (state === 'is-busy') it.btn.textContent = 'Saving…';
        else if (state === 'is-err') it.btn.textContent = 'Couldn’t save — will retry';
        else it.btn.textContent = it.done ? '✓ Done' : 'Mark done';
    }

    var switching = false; /* true once Switch is tapped — nothing may queue */
    function queuePush(op) {
        if (switching) return;
        try {
            var q = JSON.parse(localStorage.getItem(QKEY) || '[]');
            /* one entry per item — the latest intended state wins */
            q = q.filter(function (o) { return o.item !== op.item; });
            q.push(op); localStorage.setItem(QKEY, JSON.stringify(q.slice(-40)));
        } catch (e) {}
    }
    function queueRemove(id) {
        /* a confirmed save must clear any stale queued op for the same item,
           or a later drain replays it and silently flips the state back
           (verifier fix 2026-08-20) */
        try {
            var q = JSON.parse(localStorage.getItem(QKEY) || '[]');
            localStorage.setItem(QKEY, JSON.stringify(q.filter(function (o) { return o.item !== id; })));
        } catch (e) {}
    }
    function queueDrain() {
        var q;
        try { q = JSON.parse(localStorage.getItem(QKEY) || '[]'); } catch (e) { q = []; }
        if (!q.length) return;
        try { localStorage.setItem(QKEY, '[]'); } catch (e) {}
        /* clearing first is safe ONLY because every failure path inside
           send() re-queues the op — including the no-token path
           (audit fix 2026-08-20: a drain used to discard ops permanently
           when the session fetch failed) */
        for (var i = 0; i < q.length; i++) send(q[i].item, q[i].done, null);
    }

    function itemById(id) {
        for (var i = 0; i < items.length; i++) if (items[i].id === id) return items[i];
        return null;
    }
    function send(id, done, it) {
        if (!it) it = itemById(id); /* drained retries repaint the button too */
        token(function (t) {
            if (!t) { queuePush({ item: id, done: done }); if (it) setBtn(it, 'is-err'); return; }
            fetch(API + '/checks', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + t },
                body: JSON.stringify({ assignment: ASSIGNMENT, item: id, done: done })
            }).then(function (r) {
                if (!r.ok) throw new Error('http ' + r.status);
                queueRemove(id);
                if (it) { it.done = done; setBtn(it, null); paint(); }
            }).catch(function () {
                queuePush({ item: id, done: done });
                if (it) setBtn(it, 'is-err');
            });
        });
    }

    if (signedIn) {
        session.hidden = false;
        var nm = wrap.getAttribute('data-member-name') || 'your account';
        session.innerHTML = 'Signed in as <b></b> — not you? <a href="#" class="pca-switch">Switch</a>';
        session.querySelector('b').textContent = nm;
        session.querySelector('.pca-switch').addEventListener('click', function (e) {
            e.preventDefault();
            /* shared-iPad hygiene: this member's queued ops must never drain
               under the next coach's token. The switching flag also blocks an
               IN-FLIGHT send from re-queueing after the wipe; the wipe itself
               waits for the sign-out to succeed so a failed sign-out (offline
               tap) keeps both the session and the queue intact. */
            switching = true;
            fetch('/members/api/session', { method: 'DELETE', credentials: 'include' })
                .then(function (r) {
                    if (!r.ok) throw new Error('signout ' + r.status);
                    /* wipe EVERY assignment's queue — a stale queue from
                       another assignment page must not drain under the next
                       coach's token either */
                    try {
                        var doomed = [];
                        for (var qi = 0; qi < localStorage.length; qi++) {
                            var qk = localStorage.key(qi);
                            if (qk && qk.indexOf('pca-q-') === 0) doomed.push(qk);
                        }
                        for (var qj = 0; qj < doomed.length; qj++) localStorage.removeItem(doomed[qj]);
                    } catch (err) {}
                    location.href = '/#/portal/signin';
                })
                .catch(function () { switching = false; });
        });

        function paintEarned(it, eng) {
            var e = eng[it.path + '|' + it.kind] || { s: 0, p: 0 };
            var done = false, label = 'Not started';
            if (it.kind === 'watch') {
                var wneed = it.expect ? it.expect * 0.6 : 45;
                done = (e.p || 0) >= 90 && (e.s || 0) >= wneed;
                label = done ? '✓ Done' : ((e.p || 0) > 0 ? e.p + '% watched' : 'Not started');
            } else {
                var sec = e.s || 0;
                var need = it.expect ? it.expect * 0.85 : (it.kind === 'listen' ? 600 : 240);
                done = sec >= need;
                var mins = Math.round(sec / 60);
                label = done ? '✓ Done' : (sec > 0
                    ? (it.expect ? mins + ' of ' + Math.round(it.expect / 60) + ' min' : mins + ' min so far')
                    : 'Not started');
            }
            it.done = done;
            it.btn.textContent = label;
            it.btn.className = 'pca-check pca-earn' + (done ? ' is-done' : '');
        }
        token(function (t) {
            if (!t) return;
            fetch(API + '/progress?assignment=' + encodeURIComponent(ASSIGNMENT), {
                headers: { 'Authorization': 'Bearer ' + t }
            }).then(function (r) { return r.json(); }).then(function (j) {
                var have = (j && j.items) || {};
                var eng = (j && j.engage) || {};
                for (var i = 0; i < items.length; i++) {
                    if (items[i].kind === 'check') {
                        if (have[items[i].id]) { items[i].done = true; setBtn(items[i], null); }
                    } else {
                        paintEarned(items[i], eng);
                    }
                }
                paint();
            }).catch(function () {});
        });
        queueDrain();
        window.addEventListener('online', queueDrain);

        for (var k = 0; k < items.length; k++) (function (it) {
            if (it.kind !== 'check') return;
            it.btn.addEventListener('click', function () {
                setBtn(it, 'is-busy');
                send(it.id, !it.done, it);
            });
        })(items[k]);
    } else {
        session.hidden = false;
        session.className += ' pca-signin';
        session.innerHTML = '<b>Sign in to track your progress</b> — your check-offs and listening only count when you’re signed in. <a href="#/portal/signin">Sign in</a>';
        for (var m = 0; m < items.length; m++) { if (items[m].kind === 'check') { items[m].btn.disabled = true; } items[m].btn.style.opacity = '.45'; }
    }
    paint();
}
})();
}catch(e){ if (window.console) console.log('pc-assign', e && e.message); }
